import HTTP from '@/utils/http'
import notification from '@/utils/notification'

export async function getLocations (query) {
  try {
    const response = await HTTP.get('locations', {
      params: query,
    })
    return response.data.data
  } catch (err) {
    notification.handleResponseError(err)
    return []
  }
}

export async function createLocation (request) {
  try {
    const response = await HTTP.post('/locations', request)
    return response.data.data
  } catch (err) {
    throw err
  }
}

export async function updateLocation (id, request) {
  try {
    await HTTP.put(`/locations/${id}`, request)
    return true
  } catch (err) {
    notification.handleResponseError(err, 'location')
    return false
  }
}

export async function getLocationDetail (siteId, query) {
  try {
    const response = await HTTP.get(`locations/${siteId}/users`, { params: query })
    return response.data.data
  } catch (err) {
    notification.handleResponseError(err)
    return {users: [], location: {}}
  }
}

export async function getUsersForSite (siteId, query) {
  try {
    const response = await HTTP.get(`locations/${siteId}/users`, { params: query })
    const locations = response.data.data
    const users = locations.users || []
    return users.filter(user => user.enabled)
  } catch (err) {
    notification.handleResponseError(err)
    return []
  }
}

export async function validateSite (siteId) {
  try {
    const response = await HTTP.get(`locations/${siteId}/ownership`)
    const ownership = response.data.data
    return ownership && ownership.isValid
  } catch (err) {
    return false
  }
}

export async function getLocationContacts (siteId) {
  try {
    const response = await HTTP.get(`/locations/${siteId}/contacts`)
    return response.data.data
  } catch (err) {
    notification.handleResponseError(err)
    throw err
  }
}

export async function getDepartmentByLocationCode (code, query) {
  try {
    const response = await HTTP.get(`/locations/${code}/department`, {
      params: query,
    })
    return response.data.data
  } catch (err) {
    notification.handleResponseError(err)
    return {}
  }
}

export async function updateUserLocations (data) {
  try {
    const response = await HTTP.post('/locations/users', data)
    return response.data.data
  } catch (err) {
    notification.handleResponseError(err)
    throw err
  }
}

export async function getSiteOptions (pageName, query) {
  try {
    const response = await HTTP.get(`/locations/${pageName}/options`, {
      params: query,
    })
    return response.data.data
  } catch (err) {
    notification.handleResponseError(err)
    throw err
  }
}
